(() => {
  const expireNewBadges = () => {
    const nowS = Date.now() / 1000;
    document.querySelectorAll('[data-new-until]').forEach((badge) => {
      if (Number(badge.dataset.newUntil) <= nowS) badge.hidden = true;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', expireNewBadges);
  } else {
    expireNewBadges();
  }

  const select = (thumb) => {
    if (!thumb || thumb.classList.contains('is-active')) return;
    const card = thumb.closest('[data-chikas-card]');
    const main = card && card.querySelector('[data-pcard-main]');
    if (!main) return;

    card.querySelectorAll('[data-pcard-thumb]').forEach((t) => {
      const on = t === thumb;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const next = new Image();
    next.srcset = thumb.dataset.srcset || '';
    next.sizes = main.sizes;
    next.src = thumb.dataset.src;
    main.classList.add('is-swapping');
    const apply = () => {
      if (!thumb.classList.contains('is-active')) return;
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      main.src = thumb.dataset.src;
      main.classList.remove('is-swapping');
    };
    if (next.decode) next.decode().then(apply, apply);
    else next.onload = next.onerror = apply;
  };

  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pcard-thumb]');
    if (!thumb) return;
    e.preventDefault();
    select(thumb);
  });

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointerover', (e) => {
    if (!finePointer.matches || e.pointerType !== 'mouse') return;
    const thumb = e.target.closest('[data-pcard-thumb]');
    if (thumb) select(thumb);
  });
})();
